<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <d2-container>
    <h2>托运单</h2>
    <el-form ref="elForm"  size="medium" label-width="100px">
      <el-row>
        <el-form-item label="托运编号" prop="dd">
          <el-input v-model="listQuery.consNo" placeholder="托运编号" clearable :style="{width: '763px'}"></el-input>
        </el-form-item>
      </el-row>
      <el-form-item size="large">
        <el-button size="small" class="filter-item" type="primary" icon="search" @click="handleFilter">查询</el-button>
        <el-button @click="resetForm">重置</el-button>
      </el-form-item>
    </el-form>


    <!--表格-->
    <el-button size="small" class="filter-item"  style="margin-left: 10px;" @click="handleCreate" type="primary" icon="edit">新增托运</el-button>
    <el-table  :data="list" v-loading.body="listLoading" size="small" stripe highlight-current-row style="width: 100%">
      <el-table-column
              prop="materialId"
              type="selection"
              width="55" label="序号">
      </el-table-column>
      <el-table-column
              prop="consNo"
              label="托运编号"
              width="380">
      </el-table-column>
      <el-table-column
              prop="consName1"
              label="托运人"
              width="280"
      >
      </el-table-column>
      <el-table-column
              prop="consName2"
              label="收货人"
              width="280"
      >
      </el-table-column>
      <el-table-column
              prop="formDate"
              label="制单时间" >
      </el-table-column>
      <el-table-column
              fixed="right"
              label="操作"
              width="300">
        <template slot-scope="scope">
          <el-button size="small" @click="handleClick(scope.row)">查看</el-button>
          <el-button size="small" type="success" @click="handleUpdate(scope.row)">编辑</el-button>
          <el-button size="small" type="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <template slot="footer">
      <div v-show="!listLoading" class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit" layout="total, sizes, prev, pager, next, jumper" :total="total"> </el-pagination>
      </div>
    </template>


    <el-dialog width="1024px" :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" v-if="dialogFormVisible">
      <form-view @close="close()" @success="close(true)" :formId="currentRow.formId" :formType="formType" :preview="preview" :key="currentRow"></form-view>
    </el-dialog>

  </d2-container>
</template>


<script>
    import {
        page,
        addObj,
        getObj,
        delObj,
        putObj
    } from '@/api/admin/sysFormConsignment/index';
    import { mapGetters } from 'vuex';
    import FormView from "../sysForm/index.vue";
    export default {
        components:{
            FormView
        },
        name: 'consignmentManager',
        data() {
            return {
                list: null,
                total: null,
                listLoading: true,
                listQuery: {
                    page: 1,
                    limit: 20,
                },
                dialogFormVisible: false,
                dialogStatus: '',
                textMap: {
                    view: '查看',
                    update: '编辑',
                    create: '创建'
                },
                currentRow:{formId:null},
                formType: 100,
                preview: false,
            }
        },
        created() {
            this.getList();
        },
        computed: {
            ...mapGetters([
                'elements'
            ])
        },
        methods: {
            getList() {
                this.listLoading = true;
                page(this.listQuery).then(response => {
                    this.list = response.rows;
                    this.total = response.total;
                    this.listLoading = false;
                })
            },
            handleFilter() {
                this.getList();
            },
            handleSizeChange(val) {
                this.listQuery.limit = val;
                this.getList();
            },
            handleCurrentChange(val) {
                this.listQuery.page = val;
                this.getList();
            },
            handleCreate() {
                this.dialogStatus = 'create';
                this.dialogFormVisible = true;
            },
            handleClick(row) {
                this.currentRow = row;
                this.preview= true;
                this.dialogFormVisible = true;
                this.dialogStatus = 'view';
            }
            ,handleUpdate(row) {
                this.currentRow = row;
                this.preview= false;
                this.dialogFormVisible = true;
                this.dialogStatus = 'update';
            },
            handleDelete(row) {
                this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        delObj(row.materialId)
                            .then(() => {
                                this.$notify({
                                    title: '成功',
                                    message: '删除成功',
                                    type: 'success',
                                    duration: 2000
                                });
                                const index = this.list.indexOf(row);
                                this.list.splice(index, 1);
                            });
                    });
            },
            create(formName) {
                const set = this.$refs;
                set[formName].validate(valid => {
                    if (valid) {
                        addObj(this.form)
                            .then(() => {
                                this.dialogFormVisible = false;
                                this.getList();
                                this.$notify({
                                    title: '成功',
                                    message: '创建成功',
                                    type: 'success',
                                    duration: 2000
                                });
                            })
                    } else {
                        return false;
                    }
                });
            },
            cancel(formName) {
                this.dialogFormVisible = false;
                const set = this.$refs;
                set[formName].resetFields();
            },
            update(formName) {
                const set = this.$refs;
                set[formName].validate(valid => {
                    if (valid) {
                        this.dialogFormVisible = false;
                        this.form.password = undefined;
                        putObj(this.form.id, this.form).then(() => {
                            this.dialogFormVisible = false;
                            this.getList();
                            this.$notify({
                                title: '成功',
                                message: '创建成功',
                                type: 'success',
                                duration: 2000
                            });
                        });
                    } else {
                        return false;
                    }
                });
            },
            resetForm:function(){},
            close(flush){
                this.preview= false;
                this.dialogFormVisible=false;
                if(flush){
                    this.getList();
                }
            },
        }
    }
</script>

